/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const monitor = {
  path: '/video-monitor',
  component: Layout,
  redirect: '/video-monitor/monitor',
  name: 'VideoMonitor',
  meta: {
    title: 'videoMonitor',
    icon: 'shexiangji',
    perm: 'cSiteMonitorDeviceManager'
  },
  children: [
    {
      path: 'monitor',
      component: () => import('@/views/device/monitor/monitor.vue'),
      name: 'Monitor',
      meta: { title: 'monitor' }
    }
  ]
}
export default monitor
